/* eslint-disable react-hooks/exhaustive-deps */
import { AutoComplete as Auto, AutoComplete  } from "primereact/autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { KeyValue } from "src/models/Core/key-value";
import * as app from "../services/AppService";
import "./Autocomplete.css";
import { AutocompleteProps } from "../models/autocomplete-props";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipElm from 'react-bootstrap/Tooltip';


export default function Autocomplete(props: AutocompleteProps & { iconClass?: string, labelElmClass?: string }) {

    const [options, setOptions] = useState<KeyValue[]>([]);

    let initValue = {
        Key: "0",
        Value: props.defaultValue || ""
    };


    const [value, setValue] = useState<any>(initValue);
    const optionsFilter = props.filter || ((r: KeyValue, text: string) => (r.Value || '').toLowerCase().includes((text || '').toLowerCase()))

    const ref = useRef<AutoComplete>(null);

    useEffect(() => {
        var item = !value || typeof (value) !== "object" ? { Key: "0", Value: props.defaultValue || "" } : value;
        let selectedItem = props.options && !(String(item.Key) === "0" && props.onEnterClicked) ?
            props.options.find((i: KeyValue) => String(i.Key) === String(item.Key)) : undefined;

        if (selectedItem)
            setValue(selectedItem);
        setOptions((+(props.min || 0) > 0 && item.Value.length < +(props.min || 0)) || !props.options ? []
            : props.options);//.filter((i: KeyValue) => optionsFilter(i, !value?"": value.Value || ""))
    }, [props.options]);

    useEffect(() => {
        if (props.defaultValue === undefined) return;
        setValue((old: any) => ({ ...old, Value: props.defaultValue || "" }));
    }, [props.defaultValue]);

    useEffect(() => {
        let selectedItem = undefined;
        if (props.model && value.Key && props.model.toString() === value.Key.toString()) return;
        try {
            selectedItem = props.options.find((item: KeyValue) => String(item.Key) === String(props.model));
        } catch (e) { }
        if (selectedItem !== undefined) {
            toggleDropdown(false);
            setValue(selectedItem)
            //selectedItemChanged(selectedItem)
        }
        else {
            selectedItemChanged({ Key: (props.model === "" ? "" : (props.model || "0").toString()), Value: props.defaultValue || "" })
        }
    }, [props.model]);

    useEffect(() => {
        if ((value && (+props.model === 0 || String(value.Key) !== String(props.model)) && document.activeElement?.id === (props.id ? props.id : "auto" + props.label) && props.onEnterClicked !== undefined) || props.onSearch !== undefined)
            toggleDropdown(true);
    }, [options]);

    function selectedItemChanged(item: KeyValue) {
        toggleDropdown(false);
        setValue(item)
        if (props.onChange && typeof (props.onChange) == "function")
            props.onChange(item.Key, item, props.elmKey, props.options);
    }

    function onInputFocus(event: any) {
        setFocus(true)
        toggleDropdown(true);
        if (props.onFocus && typeof props.onFocus == "function") props.onFocus();
    }

    function hanldeKeydown(evt: any) {
        if (evt.charCode === 13) {
            evt.preventDefault();
            setValue(initValue)
            if (props.onEnterClicked && typeof props.onEnterClicked == "function") {
                if (typeof value === "string") {
                    props.onEnterClicked(value);
                } else if (typeof value === "object") {
                    props.onEnterClicked(value.Value);
                }
            }
        }
    }

    function toggleDropdown(show: boolean) {
        if (ref.current) {
            if (options?.length && show) {
                ref.current.show();
            } else if (options?.length)
                ref.current.hide();
        }
    }

    function search(Value: any) {
        if (typeof (Value) === "object") return;
        let text = Value !== undefined ? Value : props.defaultValue;
        let item: KeyValue = { Value: text, Key: '0' };

        setValue(item);
        toggleDropdown(true);
        var options = +(props.min || 0) > 0 && Value.length < +(props.min || 0) ? [] : [
            ...props.options.filter((i: KeyValue) => optionsFilter(i, Value || "")),
        ];
        setOptions(options);
        if (props.onSearch && typeof (props.onSearch) == "function")
            props.onSearch(text);
        else if (options.length === 1 && options?.[0]?.Value === Value)
            selectedItemChanged(options[0])
    }

    function ItemTemplate(item: KeyValue) {
        return (
            <div className={"flex align-items-center" + (+item.Key === 0 && props.showNewWord ? " bold" : "")}            >
                <div>
                    {" "}{+item.Key === 0 && props.showNewWord ? `( ${item.Value} )${app.translate("new")}` : item.Value}{" "}
                </div>
            </div>
        );
    }

    const [focus, setFocus] = useState<boolean | undefined>(undefined);
    const [timer, setTimer] = useState<NodeJS.Timeout>();

    useEffect(() => {
        clearTimeout(timer);
        setTimer(setTimeout(() => {
            if (focus === false)
                setValue((old: any) => {
                    var item = old && typeof (old) === "object" ? old : { Key: "0", Value: (old && typeof (old) === "string") ? old : (props.defaultValue || "") }
                    if (props.onBlur && document.activeElement?.id !== (props.id ? props.id : "auto" + props.label))
                        props.onBlur?.(item);
                    var selected = props.options.find((i: KeyValue) => String(i.Key) === String(item.Key))
                    if (!selected && props.onBlur === undefined && props.onFocus === undefined && props.onEnterClicked === undefined) {
                        selectedItemChanged({ Key: "", Value: "" })
                        return "";
                    }
                    return old;
                })
        }, 300))
    }, [focus]);

    const renderButtons = () => {
        if (props.icon) {
            const IconButton = (
                <button className={`btn ${props.iconClass || "btn-primary border-0 "}  p-0 px-2`} type="button"
                    disabled={!props.iconClicked}
                    onClick={() => props.iconClicked?.(value)} >
                    <i className={` iconssc-${props.icon}`} />
                </button>
            );

            if (props.iconTooltip) {
                return (
                    <OverlayTrigger key={props.elmKey + 'bottom'} placement='bottom'
                        overlay={
                            <TooltipElm style={{ position: "fixed" }} id={`tooltip-bottom`}>
                                {app.translate(props.iconTooltip)}
                            </TooltipElm>
                        }>
                        {IconButton}
                    </OverlayTrigger>
                )
            }
            return IconButton;
        }
        return null;
    }

    const renderLabelElm = () => {
        if (props.labelElm === undefined) return null;
        const raw = props.labelElm;
        const num = Number(String(raw).replace(/,/g, ""));
        const isNumber = !isNaN(num);
        if (isNumber) {
            // choose classes based on sign
            let badgeCls = props.labelElmClass ? props.labelElmClass : "badge rounded-pill px-3 py-1 ";
            if (!props.labelElmClass) {
                if (num > 0) badgeCls += "bg-success-subtle border border-success text-success";
                else if (num < 0) badgeCls += "bg-danger-subtle border border-danger text-danger";
                else badgeCls += "bg-warning-subtle border border-warning text-warning";
            }
            const display = typeof app.roundNumber === "function"
                ? app.roundNumber(num, +(props as any).currencyID || 0, true)
                : String(num);
            return (
                <span title={String(raw)} className={`${badgeCls} fw-semibold me-2`} style={{ marginBottom:"2px" }}>
                    {app.translate("Balance")} : {display}
                </span>
            );
        }
        return (
            <label className={`fw-semibold me-2 mb-1 ${props.labelElmClass || ""}`}>
                {props.labelElm}
            </label>
        );
    }
    return (
        <div className={`auto-control ${props.containerClass} margin-top `}>
            {props.label && !props.isTable && (
                <div className="d-flex justify-content-between ">
                <label className={`fw-semibold ms-1 ${props.labelClass || "text-primary-emphasis"}`}>
                    {app.translate(props.label)}
                </label>
                    {renderLabelElm()}
             </div>
            )}

            <div className={` ctr border rounded  focus-group ${props.disabled
                ? " autocomplete-disabled pe-none"
                : "bg-light-subtle"
                       }`}>
                <div className=" w-100 input-group d-flex  flex-nowrap">
                    <Auto
                        placeholder={app.translate(props.placeHolder)}
                        ref={ref}
                        field="Value"
                        delay={0}
                        minLength={+(props.min || 0)}
                        key={props.elmKey}
                        inputId={props.id ? props.id : "auto" + props.label}
                        disabled={props.disabled}
                        onKeyPress={hanldeKeydown}
                        onSelect={e => selectedItemChanged(e.value)}
                        onFocus={onInputFocus}
                        completeMethod={(e) => search(e.query)}
                        onClick={() => {
                            toggleDropdown(true);
                            setOptions(!value || !props.options || (+(props.min || 0) > 0 && value.Value.length < +(props.min || 0)) ? []
                                : props.options);
                        }}
                        value={value}
                        suggestions={options}
                        onChange={(e) => {
                            setValue(e.value)
                            e.originalEvent?.preventDefault();
                        }}
                            onBlur={() => setFocus(false)}
                            className={`border-0 ${props.icon ? 'autocomplete-with-icon' : 'rounded '} ${props.required ? "is-invalid  border-1" : "border border-0 " + props.class}`}
                            required={props.required}
                            itemTemplate={ItemTemplate}
                            ></Auto>
                           {renderButtons()}
                </div>
            </div>
        </div>
    );
}